/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    StationDataValidationError,
    StationDataValidationErrorFromJSON,
    StationDataValidationErrorFromJSONTyped,
    StationDataValidationErrorToJSON,
} from './';

/**
 * 
 * @export
 * @interface UploadStationsResponse
 */
export interface UploadStationsResponse {
    /**
     * 
     * @type {boolean}
     * @memberof UploadStationsResponse
     */
    hasErrors?: boolean;
    /**
     * 
     * @type {number}
     * @memberof UploadStationsResponse
     */
    waterMark?: number;
    /**
     * 
     * @type {Array<StationDataValidationError>}
     * @memberof UploadStationsResponse
     */
    errors?: Array<StationDataValidationError> | null;
}

export function UploadStationsResponseFromJSON(json: any): UploadStationsResponse {
    return UploadStationsResponseFromJSONTyped(json, false);
}

export function UploadStationsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UploadStationsResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'hasErrors': !exists(json, 'hasErrors') ? undefined : json['hasErrors'],
        'waterMark': !exists(json, 'waterMark') ? undefined : json['waterMark'],
        'errors': !exists(json, 'errors') ? undefined : (json['errors'] === null ? null : (json['errors'] as Array<any>).map(StationDataValidationErrorFromJSON)),
    };
}

export function UploadStationsResponseToJSON(value?: UploadStationsResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'hasErrors': value.hasErrors,
        'waterMark': value.waterMark,
        'errors': value.errors === undefined ? undefined : (value.errors === null ? null : (value.errors as Array<any>).map(StationDataValidationErrorToJSON)),
    };
}


